import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { RelatedCoursesAll } from 'src/common/components/RelatedCoursesAll';
import { SwiperOptions } from 'swiper';

const StyledRelatedCourses = styled(RelatedCoursesAll)`
  margin-top: 3.4375rem;

  ${media.w.min.px992(css`
    margin-top: 3.75rem;
  `)};

  ${media.w.min.px1200(css`
    margin-top: 5rem;
  `)};
`;

const swiperOptions: SwiperOptions = {
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 3,
    },
  },
};

export interface ElearningRelatedProps {
  elearningId?: number;
}

export const ElearningRelated: FC<ElearningRelatedProps> = ({ elearningId }) => (
  <StyledRelatedCourses id={elearningId} swiperOptions={swiperOptions} />
);
